import { Component, Input } from '@angular/core';
import _ from 'lodash';

@Component({
    selector: 'app-rej-icon',
    template: `<fa-icon [icon]="['fas', appRejIconStyling(item, organizationName, moduleType, true)]" [ngClass]="appRejIconStyling(item, organizationName, moduleType)"></fa-icon>`
})
export class AppRejIconComponent {
    @Input() item: any;
    @Input() organizationName: string;
    @Input() moduleType: string;

    appRejIconStyling(item: any, organizationName: string, moduleType: string, isIconType = false): string {
        let statusCodes: string[];
        switch (moduleType) {
            case 'VesselNotification':
                statusCodes = ['X', 'Z', 'D', 'U', 'RM'];
                break;
            case 'Conveyance':
                statusCodes = ['CN', 'X', 'D', 'U'];
                break;
            case 'VesselPermit':
                statusCodes = ['CAN', 'DIS', 'DRA', 'AMN'];
                break;
            case 'VesselShift':
                statusCodes = ['C', 'X', 'D', 'U'];
                break;
        }

        if (!statusCodes.includes(item?.statusId) && (organizationName !== 'inspection' || item.notificationTypeId !== 'D')) {
            if (item?.[organizationName ? `${organizationName}ApprovalDate` : 'approvalDate'] && organizationName !== 'portStateControl') {
                return isIconType ? 'check-circle' : 'greenIcon';
            } else if (item?.[organizationName ? `${organizationName}RejectionDate` : 'rejectionDate']) {
                return isIconType ? 'times-circle' : 'redIcon';
            } else if (['W', 'WAP', 'WEX', 'WA'].includes(item?.statusId) && organizationName !== 'portStateControl') {
                return isIconType ? 'clock' : 'orangeIcon';
            }
        }

        return isIconType ? 'circle' : 'grayIcon';
    }
}
